const { createContext } = require("react");
const MenuContext = createContext({});
export {MenuContext};
